/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ISearchData, ISearchViewProps } from '@msdyn365-commerce-modules/search';
import { Node } from '@msdyn365-commerce-modules/utilities';
import React from 'react';

import { ISearchProps } from '../../definition-extensions/search.ext.props.autogenerated';

/**
 * Render Categories heading.
 * @param inCategoriesHeading - The Keywords result heading.
 * @returns The JSX Element.
 */
const renderCategorySuggestionsTitle = (inCategoriesHeading: string): JSX.Element => {
    const categoryAutoSuggestionHeading = inCategoriesHeading ? inCategoriesHeading : 'In categories';

    return (
        <div className='msc-autoSuggest__categoryResults-title'>
            {categoryAutoSuggestionHeading}
        </div>
    );
};

/**
 * Render Categories suggestion result.
 * @param inCategoriesHeading - The Categories result heading.
 * @param noResultText - The "No Result" text.
 * @param props - The Categories suggestion result.
 * @returns The JSX Element.
 */
export const CategorySuggestionsComponent = (
    inCategoriesHeading: string,
    noResultText: string,
    props: ISearchViewProps & ISearchProps<ISearchData>
): JSX.Element => {
    return props.autosuggestCategory ? (
        <Node {...props.CategorySuggest}>
            {renderCategorySuggestionsTitle(inCategoriesHeading)}
            <Node {...props.UlCategory}>
                {props.autosuggestCategory.text.map(text => {
                    return text;
                })}
            </Node>
        </Node>
    ) : (
        <Node {...props.CategorySuggest}>
            {renderCategorySuggestionsTitle(inCategoriesHeading)}
            <Node {...props.UlCategory}>
                <li className='msc-autoSuggest__categoryResults-no-results'>
                    {noResultText}
                </li>
            </Node>
        </Node>
    );
};
